<div class="card">
  <video controls>
    <source [src]="videoUrl" />
    Your browser does not support the video tag.
  </video>
  <p class="tag">{{ tag }}</p>
  <p class="title">{{ title }}</p>
  <p class="description">{{ description }}</p>
</div>
